import i18n from '@/i18n';

if (localStorage.getItem('lang')) {
  i18n.locale = localStorage.getItem('lang');
}
export const EU_COUNTRIES = 'AT, BE, BG, CY, CZ, DE, DK, EE, ES, FI, FR, GB, GR, HR, HU, IC, IE, IT, LT, LU, LV, MT, NL, PL, PT, RO, SE, SI, SK'
export const NON_EU_COUNTRIES = 'AD, AE, AF, AG, AI, AL, AM, AO, AQ, AR, AS, AU, AW, AX, AZ, BA, BB, BD, BF, BH, BI, BJ, BL, BM, BN, BO, BQ, BR, BS, BT, BV, BW, BY, BZ, CA, CC, CD, CF, CG, CH, CI, CK, CL, CM, CN, CO, CR, CU, CV, CW, CX, DJ, DM, DO, DZ, EC, EG, EH, ER, ET, FJ, FK, FM, FO, GA, GD, GE, GF, GG, GH, GI, GL, GM, GN, GP, GQ, GS, GT, GU, GW, GY, HK, HM, HN, HT, ID, IL, IM, IN, IO, IQ, IR, IS, JE, JM, JO, JP, KE, KG, KH, KI, KM, KN, KP, KR, KW, KY, KZ, LA, LB, LC, LI, LK, LR, LS, LY, MA, MC, MD, ME, MF, MG, MH, MK, ML, MM, MN, MO, MP, MQ, MR, MS, MU, MV, MW, MX, MY, MZ, NA, NC, NE, NF, NG, NI, NO, NP, NR, NU, NZ, OM, PA, PE, PF, PG, PH, PK, PM, PN, PR, PS, PW, PY, QA, RE, RS, RU, RW, SA, SB, SC, SD, SG, SH, SJ, SL, SM, SN, SO, SR, SS, ST, SV, SX, SY, SZ, TC, TD, TF, TG, TH, TJ, TK, TL, TM, TN, TO, TR, TT, TV, TW, TZ, UA, UG, UM, US, UY, UZ, VA, VC, VE, VG, VI, VN, VU, WF, WS, YE, YT, ZA, ZM, ZW'

/* eslint-disable */
export default [{
  id: '1',
  name: i18n.t('Afghanistan'),
  alpha2: 'AF',
  alpha3: 'AFG',
  country_number: '4',
  dial_code: '93',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '2',
  name: i18n.t('Åland Islands'),
  alpha2: 'AX',
  alpha3: 'ALA',
  country_number: '248',
  dial_code: '358',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '3',
  name: i18n.t('Albania'),
  alpha2: 'AL',
  alpha3: 'ALB',
  country_number: '8',
  dial_code: '355',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '4',
  name: i18n.t('Algeria'),
  alpha2: 'DZ',
  alpha3: 'DZA',
  country_number: '12',
  dial_code: '213',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '5',
  name: i18n.t('American Samoa'),
  alpha2: 'AS',
  alpha3: 'ASM',
  country_number: '16',
  dial_code: '1684',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '6',
  name: i18n.t('Andorra'),
  alpha2: 'AD',
  alpha3: 'AND',
  country_number: '20',
  dial_code: '376',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '7',
  name: i18n.t('Angola'),
  alpha2: 'AO',
  alpha3: 'AGO',
  country_number: '24',
  dial_code: '244',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '8',
  name: i18n.t('Anguilla'),
  alpha2: 'AI',
  alpha3: 'AIA',
  country_number: '660',
  dial_code: '1264',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '9',
  name: i18n.t('Antarctica'),
  alpha2: 'AQ',
  alpha3: 'ATA',
  country_number: '10',
  dial_code: '672',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '10',
  name: i18n.t('Antigua and Barbuda'),
  alpha2: 'AG',
  alpha3: 'ATG',
  country_number: '28',
  dial_code: '1268',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '11',
  name: i18n.t('Argentina'),
  alpha2: 'AR',
  alpha3: 'ARG',
  country_number: '32',
  dial_code: '54',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '12',
  name: i18n.t('Armenia'),
  alpha2: 'AM',
  alpha3: 'ARM',
  country_number: '51',
  dial_code: '374',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '13',
  name: i18n.t('Aruba'),
  alpha2: 'AW',
  alpha3: 'ABW',
  country_number: '533',
  dial_code: '297',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '14',
  name: i18n.t('Australia'),
  alpha2: 'AU',
  alpha3: 'AUS',
  country_number: '36',
  dial_code: '61',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '15',
  name: i18n.t('Austria'),
  alpha2: 'AT',
  alpha3: 'AUT',
  country_number: '40',
  dial_code: '43',
  has_state: '1',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '16',
  name: i18n.t('Azerbaijan'),
  alpha2: 'AZ',
  alpha3: 'AZE',
  country_number: '31',
  dial_code: '994',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '17',
  name: i18n.t('Bahamas'),
  alpha2: 'BS',
  alpha3: 'BHS',
  country_number: '44',
  dial_code: '1242',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '18',
  name: i18n.t('Bahrain'),
  alpha2: 'BH',
  alpha3: 'BHR',
  country_number: '48',
  dial_code: '973',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '19',
  name: i18n.t('Bangladesh'),
  alpha2: 'BD',
  alpha3: 'BGD',
  country_number: '50',
  dial_code: '880',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '20',
  name: i18n.t('Barbados'),
  alpha2: 'BB',
  alpha3: 'BRB',
  country_number: '52',
  dial_code: '1246',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '21',
  name: i18n.t('Belarus'),
  alpha2: 'BY',
  alpha3: 'BLR',
  country_number: '112',
  dial_code: '375',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '22',
  name: i18n.t('Belgium'),
  alpha2: 'BE',
  alpha3: 'BEL',
  country_number: '56',
  dial_code: '32',
  has_state: '1',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '23',
  name: i18n.t('Belize'),
  alpha2: 'BZ',
  alpha3: 'BLZ',
  country_number: '84',
  dial_code: '501',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '24',
  name: i18n.t('Benin'),
  alpha2: 'BJ',
  alpha3: 'BEN',
  country_number: '204',
  dial_code: '229',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '25',
  name: i18n.t('Bermuda'),
  alpha2: 'BM',
  alpha3: 'BMU',
  country_number: '60',
  dial_code: '1441',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '26',
  name: i18n.t('Bhutan'),
  alpha2: 'BT',
  alpha3: 'BTN',
  country_number: '64',
  dial_code: '975',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '27',
  name: i18n.t('Bolivia'),
  alpha2: 'BO',
  alpha3: 'BOL',
  country_number: '68',
  dial_code: '591',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '28',
  name: i18n.t('Bonaire'),
  alpha2: 'BQ',
  alpha3: 'BES',
  country_number: '535',
  dial_code: '591',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '29',
  name: i18n.t('Bosnia and Herzegovina'),
  alpha2: 'BA',
  alpha3: 'BIH',
  country_number: '70',
  dial_code: '387',
  has_state: '1',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '30',
  name: i18n.t('Botswana'),
  alpha2: 'BW',
  alpha3: 'BWA',
  country_number: '72',
  dial_code: '267',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '31',
  name: i18n.t('Bouvet Island'),
  alpha2: 'BV',
  alpha3: 'BVT',
  country_number: '74',
  dial_code: '267',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '32',
  name: i18n.t('Brazil'),
  alpha2: 'BR',
  alpha3: 'BRA',
  country_number: '76',
  dial_code: '55',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '33',
  name: i18n.t('British Indian Ocean Territory'),
  alpha2: 'IO',
  alpha3: 'IOT',
  country_number: '86',
  dial_code: '246',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '34',
  name: i18n.t('Brunei Darussalam'),
  alpha2: 'BN',
  alpha3: 'BRN',
  country_number: '96',
  dial_code: '673',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '35',
  name: i18n.t('Bulgaria'),
  alpha2: 'BG',
  alpha3: 'BGR',
  country_number: '100',
  dial_code: '359',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '36',
  name: i18n.t('Burkina Faso'),
  alpha2: 'BF',
  alpha3: 'BFA',
  country_number: '854',
  dial_code: '226',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '37',
  name: i18n.t('Burundi'),
  alpha2: 'BI',
  alpha3: 'BDI',
  country_number: '108',
  dial_code: '257',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '38',
  name: i18n.t('Cambodia'),
  alpha2: 'KH',
  alpha3: 'KHM',
  country_number: '116',
  dial_code: '855',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '39',
  name: i18n.t('Cameroon'),
  alpha2: 'CM',
  alpha3: 'CMR',
  country_number: '120',
  dial_code: '237',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '236',
  name: i18n.t('United States of America'),
  alpha2: 'US',
  alpha3: 'USA',
  country_number: '840',
  dial_code: '1',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '40',
  name: i18n.t('Canada'),
  alpha2: 'CA',
  alpha3: 'CAN',
  country_number: '124',
  dial_code: '1',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '41',
  name: i18n.t('Cabo Verde'),
  alpha2: 'CV',
  alpha3: 'CPV',
  country_number: '132',
  dial_code: '238',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '42',
  name: i18n.t('Cayman Islands'),
  alpha2: 'KY',
  alpha3: 'CYM',
  country_number: '136',
  dial_code: '345',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '43',
  name: i18n.t('Central African Republic'),
  alpha2: 'CF',
  alpha3: 'CAF',
  country_number: '140',
  dial_code: '236',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '44',
  name: i18n.t('Chad'),
  alpha2: 'TD',
  alpha3: 'TCD',
  country_number: '148',
  dial_code: '235',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '45',
  name: i18n.t('Chile'),
  alpha2: 'CL',
  alpha3: 'CHL',
  country_number: '152',
  dial_code: '56',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '46',
  name: i18n.t('China'),
  alpha2: 'CN',
  alpha3: 'CHN',
  country_number: '156',
  dial_code: '86',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '47',
  name: i18n.t('Christmas Island'),
  alpha2: 'CX',
  alpha3: 'CXR',
  country_number: '162',
  dial_code: '61',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '48',
  name: i18n.t('Cocos (Keeling) Islands'),
  alpha2: 'CC',
  alpha3: 'CCK',
  country_number: '166',
  dial_code: '61',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '49',
  name: i18n.t('Colombia'),
  alpha2: 'CO',
  alpha3: 'COL',
  country_number: '170',
  dial_code: '57',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '50',
  name: i18n.t('Comoros'),
  alpha2: 'KM',
  alpha3: 'COM',
  country_number: '174',
  dial_code: '269',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '51',
  name: i18n.t('Congo'),
  alpha2: 'CG',
  alpha3: 'COG',
  country_number: '178',
  dial_code: '242',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '52',
  name: i18n.t('Congo (Democratic Republic of the)'),
  alpha2: 'CD',
  alpha3: 'COD',
  country_number: '180',
  dial_code: '243',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '53',
  name: i18n.t('Cook Islands'),
  alpha2: 'CK',
  alpha3: 'COK',
  country_number: '184',
  dial_code: '682',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '54',
  name: i18n.t('Costa Rica'),
  alpha2: 'CR',
  alpha3: 'CRI',
  country_number: '188',
  dial_code: '506',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '55',
  name: i18n.t("Côte d\\'Ivoire"),
  alpha2: 'CI',
  alpha3: 'CIV',
  country_number: '384',
  dial_code: '225',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '56',
  name: i18n.t('Croatia'),
  alpha2: 'HR',
  alpha3: 'HRV',
  country_number: '191',
  dial_code: '385',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '57',
  name: i18n.t('Cuba'),
  alpha2: 'CU',
  alpha3: 'CUB',
  country_number: '192',
  dial_code: '53',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '58',
  name: i18n.t('Curaçao'),
  alpha2: 'CW',
  alpha3: 'CUW',
  country_number: '531',
  dial_code: '53',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '59',
  name: i18n.t('Cyprus'),
  alpha2: 'CY',
  alpha3: 'CYP',
  country_number: '196',
  dial_code: '537',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '60',
  name: i18n.t('Czech Republic'),
  alpha2: 'CZ',
  alpha3: 'CZE',
  country_number: '203',
  dial_code: '420',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '61',
  name: i18n.t('Denmark'),
  alpha2: 'DK',
  alpha3: 'DNK',
  country_number: '208',
  dial_code: '45',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '62',
  name: i18n.t('Djibouti'),
  alpha2: 'DJ',
  alpha3: 'DJI',
  country_number: '262',
  dial_code: '253',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '63',
  name: i18n.t('Dominica'),
  alpha2: 'DM',
  alpha3: 'DMA',
  country_number: '212',
  dial_code: '1767',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '64',
  name: i18n.t('Dominican Republic'),
  alpha2: 'DO',
  alpha3: 'DOM',
  country_number: '214',
  dial_code: '1849',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '65',
  name: i18n.t('Ecuador'),
  alpha2: 'EC',
  alpha3: 'ECU',
  country_number: '218',
  dial_code: '593',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '66',
  name: i18n.t('Egypt'),
  alpha2: 'EG',
  alpha3: 'EGY',
  country_number: '818',
  dial_code: '20',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '67',
  name: i18n.t('El Salvador'),
  alpha2: 'SV',
  alpha3: 'SLV',
  country_number: '222',
  dial_code: '503',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '68',
  name: i18n.t('Equatorial Guinea'),
  alpha2: 'GQ',
  alpha3: 'GNQ',
  country_number: '226',
  dial_code: '240',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '69',
  name: i18n.t('Eritrea'),
  alpha2: 'ER',
  alpha3: 'ERI',
  country_number: '232',
  dial_code: '291',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '70',
  name: i18n.t('Estonia'),
  alpha2: 'EE',
  alpha3: 'EST',
  country_number: '233',
  dial_code: '372',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '71',
  name: i18n.t('Ethiopia'),
  alpha2: 'ET',
  alpha3: 'ETH',
  country_number: '231',
  dial_code: '251',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '72',
  name: i18n.t('Falkland Islands (Malvinas)'),
  alpha2: 'FK',
  alpha3: 'FLK',
  country_number: '238',
  dial_code: '500',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '73',
  name: i18n.t('Faroe Islands'),
  alpha2: 'FO',
  alpha3: 'FRO',
  country_number: '234',
  dial_code: '298',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '74',
  name: i18n.t('Fiji'),
  alpha2: 'FJ',
  alpha3: 'FJI',
  country_number: '242',
  dial_code: '679',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '75',
  name: i18n.t('Finland'),
  alpha2: 'FI',
  alpha3: 'FIN',
  country_number: '246',
  dial_code: '358',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '76',
  name: i18n.t('France'),
  alpha2: 'FR',
  alpha3: 'FRA',
  country_number: '250',
  dial_code: '33',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '77',
  name: i18n.t('French Guiana'),
  alpha2: 'GF',
  alpha3: 'GUF',
  country_number: '254',
  dial_code: '594',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '78',
  name: i18n.t('French Polynesia'),
  alpha2: 'PF',
  alpha3: 'PYF',
  country_number: '258',
  dial_code: '689',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '79',
  name: i18n.t('French Southern Territories'),
  alpha2: 'TF',
  alpha3: 'ATF',
  country_number: '260',
  dial_code: '689',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '80',
  name: i18n.t('Gabon'),
  alpha2: 'GA',
  alpha3: 'GAB',
  country_number: '266',
  dial_code: '241',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '81',
  name: i18n.t('Gambia'),
  alpha2: 'GM',
  alpha3: 'GMB',
  country_number: '270',
  dial_code: '220',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '82',
  name: i18n.t('Georgia'),
  alpha2: 'GE',
  alpha3: 'GEO',
  country_number: '268',
  dial_code: '995',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '83',
  name: i18n.t('Germany'),
  alpha2: 'DE',
  alpha3: 'DEU',
  country_number: '276',
  dial_code: '49',
  has_state: '1',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '84',
  name: i18n.t('Ghana'),
  alpha2: 'GH',
  alpha3: 'GHA',
  country_number: '288',
  dial_code: '233',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '85',
  name: i18n.t('Gibraltar'),
  alpha2: 'GI',
  alpha3: 'GIB',
  country_number: '292',
  dial_code: '350',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '86',
  name: i18n.t('Greece'),
  alpha2: 'GR',
  alpha3: 'GRC',
  country_number: '300',
  dial_code: '30',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '87',
  name: i18n.t('Greenland'),
  alpha2: 'GL',
  alpha3: 'GRL',
  country_number: '304',
  dial_code: '299',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '88',
  name: i18n.t('Grenada'),
  alpha2: 'GD',
  alpha3: 'GRD',
  country_number: '308',
  dial_code: '1473',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '89',
  name: i18n.t('Guadeloupe'),
  alpha2: 'GP',
  alpha3: 'GLP',
  country_number: '312',
  dial_code: '590',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '90',
  name: i18n.t('Guam'),
  alpha2: 'GU',
  alpha3: 'GUM',
  country_number: '316',
  dial_code: '1671',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '91',
  name: i18n.t('Guatemala'),
  alpha2: 'GT',
  alpha3: 'GTM',
  country_number: '320',
  dial_code: '502',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '235',
  name: i18n.t('United Kingdom'),
  alpha2: 'GB',
  alpha3: 'GBR',
  country_number: '826',
  dial_code: '44',
  has_state: '1',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '92',
  name: i18n.t('Guernsey'),
  alpha2: 'GG',
  alpha3: 'GGY',
  country_number: '831',
  dial_code: '44',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '93',
  name: i18n.t('Guinea'),
  alpha2: 'GN',
  alpha3: 'GIN',
  country_number: '324',
  dial_code: '224',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '94',
  name: i18n.t('Guinea-Bissau'),
  alpha2: 'GW',
  alpha3: 'GNB',
  country_number: '624',
  dial_code: '245',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '95',
  name: i18n.t('Guyana'),
  alpha2: 'GY',
  alpha3: 'GUY',
  country_number: '328',
  dial_code: '595',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '96',
  name: i18n.t('Haiti'),
  alpha2: 'HT',
  alpha3: 'HTI',
  country_number: '332',
  dial_code: '509',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '97',
  name: i18n.t('Heard Island and McDonald Islands'),
  alpha2: 'HM',
  alpha3: 'HMD',
  country_number: '334',
  dial_code: '509',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '98',
  name: i18n.t('Holy See'),
  alpha2: 'VA',
  alpha3: 'VAT',
  country_number: '336',
  dial_code: '379',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '99',
  name: i18n.t('Honduras'),
  alpha2: 'HN',
  alpha3: 'HND',
  country_number: '340',
  dial_code: '504',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '100',
  name: i18n.t('Hong Kong'),
  alpha2: 'HK',
  alpha3: 'HKG',
  country_number: '344',
  dial_code: '852',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '101',
  name: i18n.t('Hungary'),
  alpha2: 'HU',
  alpha3: 'HUN',
  country_number: '348',
  dial_code: '36',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '102',
  name: i18n.t('Iceland'),
  alpha2: 'IS',
  alpha3: 'ISL',
  country_number: '352',
  dial_code: '354',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '103',
  name: i18n.t('India'),
  alpha2: 'IN',
  alpha3: 'IND',
  country_number: '356',
  dial_code: '91',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '104',
  name: i18n.t('Indonesia'),
  alpha2: 'ID',
  alpha3: 'IDN',
  country_number: '360',
  dial_code: '62',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '105',
  name: i18n.t('Iran'),
  alpha2: 'IR',
  alpha3: 'IRN',
  country_number: '364',
  dial_code: '98',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '106',
  name: i18n.t('Iraq'),
  alpha2: 'IQ',
  alpha3: 'IRQ',
  country_number: '368',
  dial_code: '964',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '107',
  name: i18n.t('Ireland'),
  alpha2: 'IE',
  alpha3: 'IRL',
  country_number: '372',
  dial_code: '353',
  has_state: '1',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '108',
  name: i18n.t('Isle of Man'),
  alpha2: 'IM',
  alpha3: 'IMN',
  country_number: '833',
  dial_code: '44',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '109',
  name: i18n.t('Israel'),
  alpha2: 'IL',
  alpha3: 'ISR',
  country_number: '376',
  dial_code: '972',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '110',
  name: i18n.t('Italy'),
  alpha2: 'IT',
  alpha3: 'ITA',
  country_number: '380',
  dial_code: '39',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '111',
  name: i18n.t('Jamaica'),
  alpha2: 'JM',
  alpha3: 'JAM',
  country_number: '388',
  dial_code: '1876',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '112',
  name: i18n.t('Japan'),
  alpha2: 'JP',
  alpha3: 'JPN',
  country_number: '392',
  dial_code: '81',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '113',
  name: i18n.t('Jersey'),
  alpha2: 'JE',
  alpha3: 'JEY',
  country_number: '832',
  dial_code: '44',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '114',
  name: i18n.t('Jordan'),
  alpha2: 'JO',
  alpha3: 'JOR',
  country_number: '400',
  dial_code: '962',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '115',
  name: i18n.t('Kazakhstan'),
  alpha2: 'KZ',
  alpha3: 'KAZ',
  country_number: '398',
  dial_code: '77',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '116',
  name: i18n.t('Kenya'),
  alpha2: 'KE',
  alpha3: 'KEN',
  country_number: '404',
  dial_code: '254',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '117',
  name: i18n.t('Kiribati'),
  alpha2: 'KI',
  alpha3: 'KIR',
  country_number: '296',
  dial_code: '686',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '118',
  name: i18n.t('North Korea'),
  alpha2: 'KP',
  alpha3: 'PRK',
  country_number: '408',
  dial_code: '850',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '119',
  name: i18n.t('South Korea'),
  alpha2: 'KR',
  alpha3: 'KOR',
  country_number: '410',
  dial_code: '82',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '120',
  name: i18n.t('Kuwait'),
  alpha2: 'KW',
  alpha3: 'KWT',
  country_number: '414',
  dial_code: '965',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '121',
  name: i18n.t('Kyrgyzstan'),
  alpha2: 'KG',
  alpha3: 'KGZ',
  country_number: '417',
  dial_code: '996',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '122',
  name: i18n.t("Lao People\\'s Democratic Republic"),
  alpha2: 'LA',
  alpha3: 'LAO',
  country_number: '418',
  dial_code: '856',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '123',
  name: i18n.t('Latvia'),
  alpha2: 'LV',
  alpha3: 'LVA',
  country_number: '428',
  dial_code: '371',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '124',
  name: i18n.t('Lebanon'),
  alpha2: 'LB',
  alpha3: 'LBN',
  country_number: '422',
  dial_code: '961',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '125',
  name: i18n.t('Lesotho'),
  alpha2: 'LS',
  alpha3: 'LSO',
  country_number: '426',
  dial_code: '266',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '126',
  name: i18n.t('Liberia'),
  alpha2: 'LR',
  alpha3: 'LBR',
  country_number: '430',
  dial_code: '231',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '127',
  name: i18n.t('Libya'),
  alpha2: 'LY',
  alpha3: 'LBY',
  country_number: '434',
  dial_code: '218',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '128',
  name: i18n.t('Liechtenstein'),
  alpha2: 'LI',
  alpha3: 'LIE',
  country_number: '438',
  dial_code: '423',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '129',
  name: i18n.t('Lithuania'),
  alpha2: 'LT',
  alpha3: 'LTU',
  country_number: '440',
  dial_code: '370',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '130',
  name: i18n.t('Luxembourg'),
  alpha2: 'LU',
  alpha3: 'LUX',
  country_number: '442',
  dial_code: '352',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '131',
  name: i18n.t('Macao'),
  alpha2: 'MO',
  alpha3: 'MAC',
  country_number: '446',
  dial_code: '853',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '132',
  name: i18n.t('Macedonia'),
  alpha2: 'MK',
  alpha3: 'MKD',
  country_number: '807',
  dial_code: '389',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '133',
  name: i18n.t('Madagascar'),
  alpha2: 'MG',
  alpha3: 'MDG',
  country_number: '450',
  dial_code: '261',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '134',
  name: i18n.t('Malawi'),
  alpha2: 'MW',
  alpha3: 'MWI',
  country_number: '454',
  dial_code: '265',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '135',
  name: i18n.t('Malaysia'),
  alpha2: 'MY',
  alpha3: 'MYS',
  country_number: '458',
  dial_code: '60',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '136',
  name: i18n.t('Maldives'),
  alpha2: 'MV',
  alpha3: 'MDV',
  country_number: '462',
  dial_code: '960',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '137',
  name: i18n.t('Mali'),
  alpha2: 'ML',
  alpha3: 'MLI',
  country_number: '466',
  dial_code: '223',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '138',
  name: i18n.t('Malta'),
  alpha2: 'MT',
  alpha3: 'MLT',
  country_number: '470',
  dial_code: '356',
  has_state: '1',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '139',
  name: i18n.t('Marshall Islands'),
  alpha2: 'MH',
  alpha3: 'MHL',
  country_number: '584',
  dial_code: '692',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '140',
  name: i18n.t('Martinique'),
  alpha2: 'MQ',
  alpha3: 'MTQ',
  country_number: '474',
  dial_code: '596',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '141',
  name: i18n.t('Mauritania'),
  alpha2: 'MR',
  alpha3: 'MRT',
  country_number: '478',
  dial_code: '222',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '142',
  name: i18n.t('Mauritius'),
  alpha2: 'MU',
  alpha3: 'MUS',
  country_number: '480',
  dial_code: '230',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '143',
  name: i18n.t('Mayotte'),
  alpha2: 'YT',
  alpha3: 'MYT',
  country_number: '175',
  dial_code: '262',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '144',
  name: i18n.t('Mexico'),
  alpha2: 'MX',
  alpha3: 'MEX',
  country_number: '484',
  dial_code: '52',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '145',
  name: i18n.t('Micronesia'),
  alpha2: 'FM',
  alpha3: 'FSM',
  country_number: '583',
  dial_code: '691',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '146',
  name: i18n.t('Moldova'),
  alpha2: 'MD',
  alpha3: 'MDA',
  country_number: '498',
  dial_code: '373',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '147',
  name: i18n.t('Monaco'),
  alpha2: 'MC',
  alpha3: 'MCO',
  country_number: '492',
  dial_code: '377',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '148',
  name: i18n.t('Mongolia'),
  alpha2: 'MN',
  alpha3: 'MNG',
  country_number: '496',
  dial_code: '976',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '149',
  name: i18n.t('Montenegro'),
  alpha2: 'ME',
  alpha3: 'MNE',
  country_number: '499',
  dial_code: '382',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '150',
  name: i18n.t('Montserrat'),
  alpha2: 'MS',
  alpha3: 'MSR',
  country_number: '500',
  dial_code: '1664',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '151',
  name: i18n.t('Morocco'),
  alpha2: 'MA',
  alpha3: 'MAR',
  country_number: '504',
  dial_code: '212',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '152',
  name: i18n.t('Mozambique'),
  alpha2: 'MZ',
  alpha3: 'MOZ',
  country_number: '508',
  dial_code: '258',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '153',
  name: i18n.t('Myanmar'),
  alpha2: 'MM',
  alpha3: 'MMR',
  country_number: '104',
  dial_code: '95',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '154',
  name: i18n.t('Namibia'),
  alpha2: 'NA',
  alpha3: 'NAM',
  country_number: '516',
  dial_code: '264',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '155',
  name: i18n.t('Nauru'),
  alpha2: 'NR',
  alpha3: 'NRU',
  country_number: '520',
  dial_code: '674',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '156',
  name: i18n.t('Nepal'),
  alpha2: 'NP',
  alpha3: 'NPL',
  country_number: '524',
  dial_code: '977',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '157',
  name: i18n.t('Netherlands'),
  alpha2: 'NL',
  alpha3: 'NLD',
  country_number: '528',
  dial_code: '31',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '158',
  name: i18n.t('New Caledonia'),
  alpha2: 'NC',
  alpha3: 'NCL',
  country_number: '540',
  dial_code: '687',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '159',
  name: i18n.t('New Zealand'),
  alpha2: 'NZ',
  alpha3: 'NZL',
  country_number: '554',
  dial_code: '64',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '160',
  name: i18n.t('Nicaragua'),
  alpha2: 'NI',
  alpha3: 'NIC',
  country_number: '558',
  dial_code: '505',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '161',
  name: i18n.t('Niger'),
  alpha2: 'NE',
  alpha3: 'NER',
  country_number: '562',
  dial_code: '227',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '162',
  name: i18n.t('Nigeria'),
  alpha2: 'NG',
  alpha3: 'NGA',
  country_number: '566',
  dial_code: '234',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '163',
  name: i18n.t('Niue'),
  alpha2: 'NU',
  alpha3: 'NIU',
  country_number: '570',
  dial_code: '683',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '164',
  name: i18n.t('Norfolk Island'),
  alpha2: 'NF',
  alpha3: 'NFK',
  country_number: '574',
  dial_code: '672',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '165',
  name: i18n.t('Northern Mariana Islands'),
  alpha2: 'MP',
  alpha3: 'MNP',
  country_number: '580',
  dial_code: '1670',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '166',
  name: i18n.t('Norway'),
  alpha2: 'NO',
  alpha3: 'NOR',
  country_number: '578',
  dial_code: '47',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '167',
  name: i18n.t('Oman'),
  alpha2: 'OM',
  alpha3: 'OMN',
  country_number: '512',
  dial_code: '968',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '168',
  name: i18n.t('Pakistan'),
  alpha2: 'PK',
  alpha3: 'PAK',
  country_number: '586',
  dial_code: '92',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '169',
  name: i18n.t('Palau'),
  alpha2: 'PW',
  alpha3: 'PLW',
  country_number: '585',
  dial_code: '680',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '170',
  name: i18n.t('Palestine'),
  alpha2: 'PS',
  alpha3: 'PSE',
  country_number: '275',
  dial_code: '970',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '171',
  name: i18n.t('Panama'),
  alpha2: 'PA',
  alpha3: 'PAN',
  country_number: '591',
  dial_code: '507',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '172',
  name: i18n.t('Papua New Guinea'),
  alpha2: 'PG',
  alpha3: 'PNG',
  country_number: '598',
  dial_code: '675',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '173',
  name: i18n.t('Paraguay'),
  alpha2: 'PY',
  alpha3: 'PRY',
  country_number: '600',
  dial_code: '595',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '174',
  name: i18n.t('Peru'),
  alpha2: 'PE',
  alpha3: 'PER',
  country_number: '604',
  dial_code: '51',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '175',
  name: i18n.t('Philippines'),
  alpha2: 'PH',
  alpha3: 'PHL',
  country_number: '608',
  dial_code: '63',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '176',
  name: i18n.t('Pitcairn'),
  alpha2: 'PN',
  alpha3: 'PCN',
  country_number: '612',
  dial_code: '872',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '177',
  name: i18n.t('Poland'),
  alpha2: 'PL',
  alpha3: 'POL',
  country_number: '616',
  dial_code: '48',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '178',
  name: i18n.t('Portugal'),
  alpha2: 'PT',
  alpha3: 'PRT',
  country_number: '620',
  dial_code: '351',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '179',
  name: i18n.t('Puerto Rico'),
  alpha2: 'PR',
  alpha3: 'PRI',
  country_number: '630',
  dial_code: '1939',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '180',
  name: i18n.t('Qatar'),
  alpha2: 'QA',
  alpha3: 'QAT',
  country_number: '634',
  dial_code: '974',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '181',
  name: i18n.t('Réunion'),
  alpha2: 'RE',
  alpha3: 'REU',
  country_number: '638',
  dial_code: '262',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '182',
  name: i18n.t('Romania'),
  alpha2: 'RO',
  alpha3: 'ROU',
  country_number: '642',
  dial_code: '40',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '183',
  name: i18n.t('Russia'),
  alpha2: 'RU',
  alpha3: 'RUS',
  country_number: '643',
  dial_code: '7',
  has_state: '1',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '184',
  name: i18n.t('Rwanda'),
  alpha2: 'RW',
  alpha3: 'RWA',
  country_number: '646',
  dial_code: '250',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '185',
  name: i18n.t('Saint Barthélemy'),
  alpha2: 'BL',
  alpha3: 'BLM',
  country_number: '652',
  dial_code: '590',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '186',
  name: i18n.t('Saint Helena'),
  alpha2: 'SH',
  alpha3: 'SHN',
  country_number: '654',
  dial_code: '290',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '187',
  name: i18n.t('Saint Kitts and Nevis'),
  alpha2: 'KN',
  alpha3: 'KNA',
  country_number: '659',
  dial_code: '1869',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '188',
  name: i18n.t('Saint Lucia'),
  alpha2: 'LC',
  alpha3: 'LCA',
  country_number: '662',
  dial_code: '1758',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '189',
  name: i18n.t('Saint Martin (French part)'),
  alpha2: 'MF',
  alpha3: 'MAF',
  country_number: '663',
  dial_code: '590',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '190',
  name: i18n.t('Saint Pierre and Miquelon'),
  alpha2: 'PM',
  alpha3: 'SPM',
  country_number: '666',
  dial_code: '508',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '191',
  name: i18n.t('Saint Vincent and the Grenadines'),
  alpha2: 'VC',
  alpha3: 'VCT',
  country_number: '670',
  dial_code: '1784',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '192',
  name: i18n.t('Samoa'),
  alpha2: 'WS',
  alpha3: 'WSM',
  country_number: '882',
  dial_code: '685',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '193',
  name: i18n.t('San Marino'),
  alpha2: 'SM',
  alpha3: 'SMR',
  country_number: '674',
  dial_code: '378',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '194',
  name: i18n.t('Sao Tome and Principe'),
  alpha2: 'ST',
  alpha3: 'STP',
  country_number: '678',
  dial_code: '239',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '195',
  name: i18n.t('Saudi Arabia'),
  alpha2: 'SA',
  alpha3: 'SAU',
  country_number: '682',
  dial_code: '966',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '196',
  name: i18n.t('Senegal'),
  alpha2: 'SN',
  alpha3: 'SEN',
  country_number: '686',
  dial_code: '221',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '197',
  name: i18n.t('Serbia'),
  alpha2: 'RS',
  alpha3: 'SRB',
  country_number: '688',
  dial_code: '381',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '198',
  name: i18n.t('Seychelles'),
  alpha2: 'SC',
  alpha3: 'SYC',
  country_number: '690',
  dial_code: '248',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '199',
  name: i18n.t('Sierra Leone'),
  alpha2: 'SL',
  alpha3: 'SLE',
  country_number: '694',
  dial_code: '232',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '200',
  name: i18n.t('Singapore'),
  alpha2: 'SG',
  alpha3: 'SGP',
  country_number: '702',
  dial_code: '65',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '201',
  name: i18n.t('Sint Maarten (Dutch part)'),
  alpha2: 'SX',
  alpha3: 'SXM',
  country_number: '534',
  dial_code: '65',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '202',
  name: i18n.t('Slovakia'),
  alpha2: 'SK',
  alpha3: 'SVK',
  country_number: '703',
  dial_code: '421',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '203',
  name: i18n.t('Slovenia'),
  alpha2: 'SI',
  alpha3: 'SVN',
  country_number: '705',
  dial_code: '386',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '204',
  name: i18n.t('Solomon Islands'),
  alpha2: 'SB',
  alpha3: 'SLB',
  country_number: '90',
  dial_code: '677',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '205',
  name: i18n.t('Somalia'),
  alpha2: 'SO',
  alpha3: 'SOM',
  country_number: '706',
  dial_code: '252',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '206',
  name: i18n.t('South Africa'),
  alpha2: 'ZA',
  alpha3: 'ZAF',
  country_number: '710',
  dial_code: '27',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '207',
  name: i18n.t('South Georgia and the South Sandwich Islands'),
  alpha2: 'GS',
  alpha3: 'SGS',
  country_number: '239',
  dial_code: '500',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '208',
  name: i18n.t('South Sudan'),
  alpha2: 'SS',
  alpha3: 'SSD',
  country_number: '728',
  dial_code: '500',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '209',
  name: i18n.t('Spain'),
  alpha2: 'ES',
  alpha3: 'ESP',
  country_number: '724',
  dial_code: '34',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '210',
  name: i18n.t('Sri Lanka'),
  alpha2: 'LK',
  alpha3: 'LKA',
  country_number: '144',
  dial_code: '94',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '211',
  name: i18n.t('Sudan'),
  alpha2: 'SD',
  alpha3: 'SDN',
  country_number: '729',
  dial_code: '249',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '212',
  name: i18n.t('Suriname'),
  alpha2: 'SR',
  alpha3: 'SUR',
  country_number: '740',
  dial_code: '597',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '213',
  name: i18n.t('Svalbard and Jan Mayen'),
  alpha2: 'SJ',
  alpha3: 'SJM',
  country_number: '744',
  dial_code: '47',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '214',
  name: i18n.t('Swaziland'),
  alpha2: 'SZ',
  alpha3: 'SWZ',
  country_number: '748',
  dial_code: '268',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '215',
  name: i18n.t('Sweden'),
  alpha2: 'SE',
  alpha3: 'SWE',
  country_number: '752',
  dial_code: '46',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '1'
}, {
  id: '216',
  name: i18n.t('Switzerland'),
  alpha2: 'CH',
  alpha3: 'CHE',
  country_number: '756',
  dial_code: '41',
  has_state: '1',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '217',
  name: i18n.t('Syrian Arab Republic'),
  alpha2: 'SY',
  alpha3: 'SYR',
  country_number: '760',
  dial_code: '963',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '218',
  name: i18n.t('Taiwan'),
  alpha2: 'TW',
  alpha3: 'TWN',
  country_number: '158',
  dial_code: '886',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '219',
  name: i18n.t('Tajikistan'),
  alpha2: 'TJ',
  alpha3: 'TJK',
  country_number: '762',
  dial_code: '992',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '220',
  name: i18n.t('Tanzania'),
  alpha2: 'TZ',
  alpha3: 'TZA',
  country_number: '834',
  dial_code: '255',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '221',
  name: i18n.t('Thailand'),
  alpha2: 'TH',
  alpha3: 'THA',
  country_number: '764',
  dial_code: '66',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '222',
  name: i18n.t('Timor-Leste'),
  alpha2: 'TL',
  alpha3: 'TLS',
  country_number: '626',
  dial_code: '670',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '223',
  name: i18n.t('Togo'),
  alpha2: 'TG',
  alpha3: 'TGO',
  country_number: '768',
  dial_code: '228',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '224',
  name: i18n.t('Tokelau'),
  alpha2: 'TK',
  alpha3: 'TKL',
  country_number: '772',
  dial_code: '690',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '225',
  name: i18n.t('Tonga'),
  alpha2: 'TO',
  alpha3: 'TON',
  country_number: '776',
  dial_code: '676',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '226',
  name: i18n.t('Trinidad and Tobago'),
  alpha2: 'TT',
  alpha3: 'TTO',
  country_number: '780',
  dial_code: '1868',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '227',
  name: i18n.t('Tunisia'),
  alpha2: 'TN',
  alpha3: 'TUN',
  country_number: '788',
  dial_code: '216',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '228',
  name: i18n.t('Turkey'),
  alpha2: 'TR',
  alpha3: 'TUR',
  country_number: '792',
  dial_code: '90',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '229',
  name: i18n.t('Turkmenistan'),
  alpha2: 'TM',
  alpha3: 'TKM',
  country_number: '795',
  dial_code: '993',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '230',
  name: i18n.t('Turks and Caicos Islands'),
  alpha2: 'TC',
  alpha3: 'TCA',
  country_number: '796',
  dial_code: '1649',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '231',
  name: i18n.t('Tuvalu'),
  alpha2: 'TV',
  alpha3: 'TUV',
  country_number: '798',
  dial_code: '688',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '232',
  name: i18n.t('Uganda'),
  alpha2: 'UG',
  alpha3: 'UGA',
  country_number: '800',
  dial_code: '256',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '233',
  name: i18n.t('Ukraine'),
  alpha2: 'UA',
  alpha3: 'UKR',
  country_number: '804',
  dial_code: '380',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '234',
  name: i18n.t('United Arab Emirates'),
  alpha2: 'AE',
  alpha3: 'ARE',
  country_number: '784',
  dial_code: '971',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '237',
  name: i18n.t('United States Minor Outlying Islands'),
  alpha2: 'UM',
  alpha3: 'UMI',
  country_number: '581',
  dial_code: '1',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '238',
  name: i18n.t('Uruguay'),
  alpha2: 'UY',
  alpha3: 'URY',
  country_number: '858',
  dial_code: '598',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '239',
  name: i18n.t('Uzbekistan'),
  alpha2: 'UZ',
  alpha3: 'UZB',
  country_number: '860',
  dial_code: '998',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '240',
  name: i18n.t('Vanuatu'),
  alpha2: 'VU',
  alpha3: 'VUT',
  country_number: '548',
  dial_code: '678',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '241',
  name: i18n.t('Venezuela'),
  alpha2: 'VE',
  alpha3: 'VEN',
  country_number: '862',
  dial_code: '58',
  has_state: '1',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '242',
  name: i18n.t('Viet Nam'),
  alpha2: 'VN',
  alpha3: 'VNM',
  country_number: '704',
  dial_code: '84',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '243',
  name: i18n.t('Virgin Islands (British)'),
  alpha2: 'VG',
  alpha3: 'VGB',
  country_number: '92',
  dial_code: '1284',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '244',
  name: i18n.t('Virgin Islands (U.S.)'),
  alpha2: 'VI',
  alpha3: 'VIR',
  country_number: '850',
  dial_code: '1340',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '245',
  name: i18n.t('Wallis and Futuna'),
  alpha2: 'WF',
  alpha3: 'WLF',
  country_number: '876',
  dial_code: '681',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '1'
}, {
  id: '246',
  name: i18n.t('Western Sahara'),
  alpha2: 'EH',
  alpha3: 'ESH',
  country_number: '732',
  dial_code: '681',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '247',
  name: i18n.t('Yemen'),
  alpha2: 'YE',
  alpha3: 'YEM',
  country_number: '887',
  dial_code: '967',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '248',
  name: i18n.t('Zambia'),
  alpha2: 'ZM',
  alpha3: 'ZMB',
  country_number: '894',
  dial_code: '260',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '249',
  name: i18n.t('Zimbabwe'),
  alpha2: 'ZW',
  alpha3: 'ZWE',
  country_number: '716',
  dial_code: '263',
  has_state: '0',
  in_europe: '0',
  member_of_the_eu: '0',
  has_postcode: '0'
}, {
  id: '250',
  name: i18n.t('Balearic Islands'),
  alpha2: 'ES-IB',
  alpha3: 'ESP',
  country_number: '724',
  dial_code: '34',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '0'
}, {
  id: '251',
  name: i18n.t('Canary Islands'),
  alpha2: 'IC',
  alpha3: 'ESP',
  country_number: '724',
  dial_code: '34',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '1',
  has_postcode: '0'
}, {
  id: '252',
  name: i18n.t('Kosovo'),
  alpha2: 'XK',
  alpha3: 'XKX',
  country_number: '383',
  dial_code: '383',
  has_state: '0',
  in_europe: '1',
  member_of_the_eu: '0',
  has_postcode: '1'
}, /// /DHL COUNTRIES with diff alpha 2
  {
    id: '253',
    name: i18n.t('Saint Barthélemy'),
    alpha2: 'XY',
    alpha3: 'BLM',
    country_number: '652',
    dial_code: '590',
    has_state: '0',
    in_europe: '0',
    member_of_the_eu: '0',
    has_postcode: '1'
  }, {
    id: '254',
    name: i18n.t('Somalialand'),
    alpha2: 'XS',
    alpha3: 'SOM',
    country_number: '706',
    dial_code: '252',
    has_state: '1',
    in_europe: '0',
    member_of_the_eu: '0',
    has_postcode: '1'
  }, {
    id: '255',
    name: i18n.t('Nevis'),
    alpha2: 'XN',
    alpha3: 'KNA',
    country_number: '659',
    dial_code: '1869',
    has_state: '1',
    in_europe: '0',
    member_of_the_eu: '0',
    has_postcode: '1'
  }, {
    id: '256',
    name: i18n.t('Sint Maarten'),
    alpha2: 'XM',
    alpha3: 'SXM',
    country_number: '534',
    dial_code: '65',
    has_state: '0',
    in_europe: '0',
    member_of_the_eu: '0',
    has_postcode: '1'
  }, {
    id: '257',
    name: i18n.t('Curaçao'),
    alpha2: 'XC',
    alpha3: 'CUW',
    country_number: '531',
    dial_code: '53',
    has_state: '0',
    in_europe: '0',
    member_of_the_eu: '0',
    has_postcode: '0'
  }, {
    id: '258',
    name: i18n.t('Bonaire'),
    alpha2: 'XB',
    alpha3: 'BES',
    country_number: '535',
    dial_code: '591',
    has_state: '0',
    in_europe: '0',
    member_of_the_eu: '0',
    has_postcode: '1'
  }, {
    id: '259',
    name: i18n.t('St. Eustatius'),
    alpha2: 'XE',
    alpha3: 'NLD',
    country_number: '528',
    dial_code: '31',
    has_state: '0',
    in_europe: '1',
    member_of_the_eu: '0',
    has_postcode: '1'
  }, /// //END DHL COUNTRIES
]
